import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/libs/supabase";
import { useAuth } from "@/hooks/useAuth";
import { fetchUserProfile } from "@/services/userService";

export const useAuthRedirect = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const { updateAuthState, isAuthenticated, loading } = useAuth();

	useEffect(() => {
		const handleAuthRedirect = async () => {
			if (loading) return; // 認証状態の読み込み中は何もしない

			const { data, error } = await supabase.auth.getSession();
			if (error) {
				console.error("認証エラー:", error);
				navigate("/login");
			} else if (data?.session) {
				try {
					const userProfile = await fetchUserProfile(data.session.user.id);
					if (userProfile) {
						updateAuthState(userProfile, true);
						// 認証後のリダイレクト先を決定
						const from = location.state?.from?.pathname || "/webapp/dashboard";
						navigate(from, { replace: true });
					} else {
						navigate("/login");
					}
				} catch (error) {
					console.error("ユーザープロフィール取得エラー:", error);
					navigate("/login");
				}
			} else if (!isAuthenticated) {
				console.log("セッションなし");
				navigate("/login");
			}
		};

		handleAuthRedirect();
	}, [isAuthenticated, loading, navigate, location, updateAuthState]);
};
